import { render } from "./NotFound.vue?vue&type=template&id=2375ce8a"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=2375ce8a&lang=css"

import exportComponent from "/n/www/reich-ages.rc.hms.harvard.edu/AGES/Front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__